import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";
import { JobsComponents, JobsStores } from "../react_isomorphic/jobs";

import { merge } from "lodash";

window.ReactComponents = merge({},
  GlobalComponents,
  HeaderComponents,
  JobsComponents
);

window.ReactStores = merge({},
  GlobalStores,
  HeaderStores,
  JobsStores
);
